import { Calendar } from "./Calendar/Calendar";
import { CalendarEntry } from "./Calendar/CalendarEntry";
import { Order } from "../Models/Order";
import { Div } from "@tblabs/truffle";


export class OrderEventsCalendar extends Calendar
{
    constructor(order: Order)
    {
        const calendarEntries = order.AsEvents.filter(x => x.IsVisibleForCustomer).map(x => ({
            Date: x.Date,
            Content: () => [new Div("calendar-event-entry").Text(x.Icon + " " + x.Label + (x.IsDone ? "✅" : ""))]
        } as CalendarEntry));

        super(calendarEntries);
    }
}
